<template>
  <nav>
    <a href="/">Hyemin Portfolio</a>    
  </nav>
</template>